import { z } from 'zod';
import { requiredString } from '../helpers';
export const Hubspot_Get_Meeting_Availability_1_ConfigValidator = z.object({
    hubspotConnection: requiredString('HubSpot Connection is required'),
    meetingSlug: requiredString('Meeting slug is required'),
    timezone: requiredString('Timezone is required'),
    durationMinutes: z.number().int().positive('Duration must be a positive integer (minutes)'),
    startTime: z.string().optional(),
    endTime: z.string().optional()
});
//# sourceMappingURL=hubspot-get-meeting-availability-1.js.map